<script>
export default {
  emits: ['dismiss'],
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  methods: {
    async onAction() {
      try {
        await this.action?.callback?.();
      } finally {
        this.$emit('dismiss');
      }
    },
  },
};
</script>

<template>
  <div class="acl-snackbar-entry">
    <div class="acl-whatsapp-snackbar" role="status" aria-live="polite">
      <span
        class="i-lucide-circle-check acl-whatsapp-snackbar__icon"
        aria-hidden="true"
      />
      <div class="acl-whatsapp-snackbar__message">{{ message }}</div>
      <div v-if="action" class="acl-whatsapp-snackbar__action-wrap">
        <button
          v-if="action.type === 'button'"
          type="button"
          class="acl-whatsapp-snackbar__action"
          @click="onAction"
        >
          {{ action.message }}
        </button>
        <router-link
          v-else-if="action.type === 'link'"
          :to="action.to"
          class="acl-whatsapp-snackbar__action"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
